<template>
  <section>
    <v-dialog v-model="dialog" persistent max-width="750px">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          <v-flex v-if="!Update_Offer">Add Promotional/Cashback Offers</v-flex>
          <v-flex v-else>Update Promotional/Cashback Offers</v-flex>
          <v-btn icon @click="CloseDialog">
            <v-icon color="text--secondary">close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-flex wrap style="padding: 10px;">
            <v-flex>
              <v-text-field v-model="Offer_Name" label="Offer Name"></v-text-field>
            </v-flex>
            <v-flex>
              <v-radio-group v-model="Offer_Type" row>
                <v-radio label="Promotional" value="Promotional"></v-radio>
                <v-radio label="Cashback" value="Cashback"></v-radio>
              </v-radio-group>
            </v-flex>
            <v-layout row wrap>
              <v-text-field v-model="Coupon_Code" label="Coupon Code"></v-text-field>
              <v-btn @click="GenerateCode">Generate Code</v-btn>
            </v-layout>
            <v-flex>
              <v-text-field v-model="Discount_Percentage" label="Discount Percentage"></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field v-model="Maximum_Amount" label="Maximum Amount"></v-text-field>
            </v-flex>
            <v-flex>
              <v-menu
                ref="Start_Date_Menu"
                v-model="Start_Date_Menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="Start_Date"
                    label="Start Date"
                    persistent-hint
                    prepend-icon="event"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="Start_Date" no-title @input="Start_Date_Menu = false"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex>
              <v-menu
                ref="End_Date_Menu"
                v-model="End_Date_Menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="End_Date"
                    label="End Date"
                    persistent-hint
                    prepend-icon="event"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="End_Date" no-title @input="End_Date_Menu = false"></v-date-picker>
              </v-menu>
            </v-flex>
            <div style="width:400px;margin:auto;border: 1px solid #d3d3d37a;">
              <v-flex>
                <img
                  id="img_promotional"
                  :src="url"
                  width="100%"
                  style="min-height: 230px;max-height: 230px;"
                />
              </v-flex>
              <v-flex style="text-align: center;">
                <v-btn color="success" @click="$refs.inputUpload.click()">Upload Offer Image</v-btn>
                <input v-show="false" ref="inputUpload" type="file" @change="SelectedFile" />
              </v-flex>
            </div>
            <v-flex v-if="Update_Offer">
              <v-switch label="Active Offer" v-model="Enable"></v-switch>
              <v-switch label="Homepage Visible" v-model="Homepage_Visible"></v-switch>
            </v-flex>
          </v-flex>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-flex style="text-align: right;">
            <v-btn v-if="!Update_Offer" color="success" @click="SubmitPromotionalOffer">Add Offer</v-btn>
            <v-btn v-else color="success" @click="UpdatePromotionalOffer">Update Offer</v-btn>
          </v-flex>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>
<script>
export default {
  props: ["dialog"],
  data() {
    return {
      Update_Offer: false,
      Offer_Name: "",
      Discount_Percentage: 0,
      Maximum_Amount: 0,
      Coupon_Code: "",
      url: null,
      Offer_Image: null,
      Start_Date: new Date().toISOString().substr(0, 10),
      End_Date: new Date().toISOString().substr(0, 10),
      Offer_Type: "Promotional",
      Start_Date_Menu: false,
      End_Date_Menu: false,
      Offer_Id: "",
      Enable: true,
      Homepage_Visible : false
    };
  },
  methods: {
    GenerateCode() {
      this.Coupon_Code =
        "PT" +
        Date.now()
          .toString(36)
          .toUpperCase();
    },
    CloseDialog() {
      this.ClearForm();
      this.$emit("close");
    },
    SelectedFile(e) {
      this.Offer_Image = e.target.files[0];
      this.url = URL.createObjectURL(this.Offer_Image);
      this.$eventHub.$emit("SNACK_BAR", {
        Show: true,
        Text: "Image Selected",
        Color: "green",
        Close: false
      });
    },
    SubmitPromotionalOffer() {
      if (
        this.Offer_Image &&
        this.Offer_Name &&
        this.Discount_Percentage &&
        this.Maximum_Amount &&
        this.Coupon_Code &&
        this.Start_Date &&
        this.End_Date
      ) {
        const fd = new FormData();
        fd.append("Offer_Image", this.Offer_Image, this.Offer_Image.name);
        fd.append("Offer_Name", this.Offer_Name);
        fd.append("Discount_Percentage", this.Discount_Percentage);
        fd.append("Maximum_Amount", this.Maximum_Amount);
        fd.append("Coupon_Code", this.Coupon_Code);
        fd.append("Start_Date", this.Start_Date);
        fd.append("End_Date", this.End_Date);
        fd.append("Offer_Type", this.Offer_Type);
        fd.append("Enable", this.Enable);
        fd.append('Homepage_Visibility',this.Homepage_Visible)

        
        this.$http
          .post(
            `${this.$store.getters.GetProductionUrl}/offers/addpromotionalorcashbock`,
            fd
          )
          .then(response => {
            this.$store.commit(
              "SetIndividualOffers",
              response["data"]["response"]
            );
            this.$eventHub.$emit("SNACK_BAR", {
              Show: true,
              Text: "Uploaded Successfully",
              Color: "green",
              Close: false
            });
            this.CloseDialog();
          })
          .catch(err => {
            this.$eventHub.$emit("SNACK_BAR", {
              Show: true,
              Text: "Failed To Upload Image",
              Color: "red",
              Close: false
            });
          });
      } else {
        this.$eventHub.$emit("SNACK_BAR", {
          Show: true,
          Text: "Fill The Complete Details",
          Color: "red",
          Close: false
        });
      }
    },
    ClearForm() {
      !this.Update_Offer ? (this.$refs.inputUpload.value = "") : "";
      this.Update_Offer = false;
      this.Offer_Name = "";
      this.Discount_Percentage = 0;
      this.Maximum_Amount = 0;
      this.Coupon_Code = "";
      this.url = null;
      this.Offer_Image = null;
      this.Start_Date = new Date().toISOString().substr(0, 10);
      (this.End_Date = new Date().toISOString().substr(0, 10)),
        (this.Offer_Id = "");
    },
    UpdateCurrentDetails(CurrentOffer) {
      this.Update_Offer = true;
      this.Offer_Id = CurrentOffer["_id"];
      this.Offer_Type = CurrentOffer["Offer_Type"];
      this.Offer_Name = CurrentOffer["Offer_Name"];
      this.Discount_Percentage = CurrentOffer["Discount_Percentage"];
      this.Maximum_Amount = CurrentOffer["Maximum_Amount"];
      this.Coupon_Code = CurrentOffer["Coupon_Code"];
      this.url = CurrentOffer["Offer_Image"];
      this.Start_Date = new Date(CurrentOffer["Start_Date"])
        .toISOString()
        .substr(0, 10);
      this.End_Date = new Date(CurrentOffer["End_Date"])
        .toISOString()
        .substr(0, 10);
      this.Enable = CurrentOffer["Enable"] ? CurrentOffer["Enable"] : false;
      this.Homepage_Visible = CurrentOffer['Homepage_Visibility'] ? CurrentOffer['Homepage_Visibility'] : false
    },
    UpdatePromotionalOffer() {
      if (
        this.Offer_Name &&
        this.Discount_Percentage &&
        this.Maximum_Amount &&
        this.Coupon_Code &&
        this.Start_Date &&
        this.End_Date
      ) {
        const fd = new FormData();
        fd.append("Offer_Id", this.Offer_Id);
        this.Offer_Image
          ? fd.append("Offer_Image", this.Offer_Image, this.Offer_Image.name)
          : "";
        fd.append("Offer_Name", this.Offer_Name);
        fd.append("Discount_Percentage", this.Discount_Percentage);
        fd.append("Maximum_Amount", this.Maximum_Amount);
        fd.append("Coupon_Code", this.Coupon_Code);
        fd.append("Start_Date", this.Start_Date);
        fd.append("End_Date", this.End_Date);
        fd.append("Offer_Type", this.Offer_Type);
        fd.append("Enable", this.Enable);
        fd.append('Homepage_Visibility',this.Homepage_Visible)

        
        this.$http
          .post(
            `${this.$store.getters.GetProductionUrl}/offers/updatepromotionalorcashbock`,
            fd
          )
          .then(response => {
            this.$store.commit(
              "UpdateIndividualOffers",
              response["data"]["response"]
            );
            this.$eventHub.$emit("SNACK_BAR", {
              Show: true,
              Text: "Successfully Uploaded",
              Color: "green",
              Close: false
            });
            this.CloseDialog();
          })
          .catch(err => {
            this.$eventHub.$emit("SNACK_BAR", {
              Show: true,
              Text: "Failed To Upload Image",
              Color: "red",
              Close: false
            });
          });
      } else {
        this.$eventHub.$emit("SNACK_BAR", {
          Show: true,
          Text: "Fill The Complete Details",
          Color: "red",
          Close: false
        });
      }
    }
  }
};
</script>
<style scoped>
</style>